/* <sst-hero-slider>: crossfading slides, dot navigation, autoplay paused on hover. */
if (!customElements.get('sst-hero-slider')) {
  customElements.define(
    'sst-hero-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        if (this.slides.length < 2) return;

        this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.dot))));
        this.addEventListener('mouseenter', () => (this.paused = true));
        this.addEventListener('mouseleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));

        // Theme Editor: jump to the slide being edited.
        this.addEventListener('shopify:block:select', (e) => {
          this.paused = true;
          this.show(this.slides.indexOf(e.target));
        });
        this.addEventListener('shopify:block:deselect', () => (this.paused = false));

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduce) {
          this.timer = setInterval(() => !this.paused && this.show(this.index + 1), Number(this.dataset.interval) || 6500);
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      show(i) {
        if (i < 0) return;
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, n) => {
          const on = n === this.index;
          slide.classList.toggle('is-active', on);
          slide.inert = !on;
        });
        this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === this.index));
      }
    }
  );
}
